const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/ui/full-height-selector/full-height-selector-open");